import { render, staticRenderFns } from "./CustomerServiceConfirmation.vue?vue&type=template&id=2c17f7a1&scoped=true&"
import script from "./CustomerServiceConfirmation.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceConfirmation.vue?vue&type=style&index=0&id=2c17f7a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17f7a1",
  null
  
)

export default component.exports